$(document).ready(function () {

  function hasEnglishURL() {
    const url = window.location.href;
    
    return url.includes('/en/');
  }
  
  // Finde das Link-Element
  var linkElement = document.querySelector('.tribe-common-anchor-thin.tribe-events-widget-events-month__view-more-link');

  // Überprüfe die aktuelle Sprache und ändere den Link entsprechend
  if (linkElement !== null) {
    if (hasEnglishURL() === true) {
      linkElement.href = 'https://sfb1265.de/en/latest/events/events/';
    } else {
      linkElement.href = 'https://sfb1265.de/aktuelles/veranstaltungen/aktuell/';
    }
  } else {
    console.warn("Element '.tribe-common-anchor-thin.tribe-events-widget-events-month__view-more-link' konnte nicht gefunden werden.");
  }

});
